import type { ErrorEvent } from '@sentry/react';

import { logger } from '@luna/logger';

import type { SentryMiddleware } from './middlewareService';

const DEFAULT_MAX_ERRORS_PER_SESSION = 20;

function getTooManyErrorsEvent(event: ErrorEvent, maxErrorsPerSession: number): ErrorEvent {
    return {
        ...event,
        message: 'Too many errors',
        extra: {
            event,
            maxErrorsPerSession,
        },
    };
}

export function createMaxErrorsPerSessionMiddleware(
    next: SentryMiddleware,
    { maxErrorsPerSession = DEFAULT_MAX_ERRORS_PER_SESSION }: { maxErrorsPerSession?: number } = {},
): SentryMiddleware {
    let count = 0;

    return (event, hint) => {
        count += 1;

        if (count > maxErrorsPerSession + 1) {
            logger.debug('Max sentry errors per session reached');
            return null;
        }

        if (count === maxErrorsPerSession + 1) {
            logger.debug(
                'Max sentry errors per session reached, sending "Too many errors" as last error',
            );
            return next(getTooManyErrorsEvent(event, maxErrorsPerSession), hint);
        }

        return next(event, hint);
    };
}
